<template>
	<div class="intermediaries">
		<ViewIntermediary />

		<div class="row">
			<div class="col-12 col-lg-6" v-if="intermediaries.length > 0">
				<div class="title-content clearfix">
					<div class="title f-l">Intermediaries</div>
					<div></div>
					<div class="f-r">
						<div class="d-flex">
							<div class="input-group my-3">
								<span class="input-group-text">
									<i class="fa fa-search"></i>
								</span>
								<input
									type="text"
									v-model="searchQuery"
									placeholder="Search intermediaries..."
									class="form-control mr-4"
								/>
							</div>

							<Dropdown
								class="fx-dropdown"
								trigger="click"
								@on-click="filterAction($event)"
								placement="bottom-end"
							>
								<div class="btn btn-primary btn-long">
									<i class="fa fa-filter"></i>
									Filter
									<div class="lds-ring" v-show="loading">
										<div></div>
										<div></div>
										<div></div>
										<div></div>
									</div>
									<i
										class="fa fa-chevron-down"
										v-show="!loading"
									></i>
								</div>
								<DropdownMenu slot="list">
									<DropdownItem name="near_me">
										<div class="clearfix">
											<i class="fa fa-map-marker-alt"></i>
											<div class="menu-text">Near Me</div>
										</div>
									</DropdownItem>
									<DropdownItem name="ratings">
										<div class="clearfix">
											<i class="fa fa-star"></i>
											<div class="menu-text">
												Ratings High to Low
											</div>
										</div>
									</DropdownItem>
									<DropdownItem name="name">
										<div class="clearfix">
											<i class="fa fa-text-width"></i>
											<div class="menu-text">Name</div>
										</div>
									</DropdownItem>
									<DropdownItem name="proffesion">
										<div class="clearfix">
											<i class="fa fa-briefcase"></i>
											<div class="menu-text">
												Proffesion
											</div>
										</div>
									</DropdownItem>
									<DropdownItem name="years_of_experience">
										<div class="clearfix">
											<i
												class="fa fa-sort-numeric-up-alt"
											></i>
											<div class="menu-text">
												Years of Experience
											</div>
										</div>
									</DropdownItem>
								</DropdownMenu>
							</Dropdown>
						</div>
					</div>
				</div>
				<div class="scroll-content">
					<scrollbar>
						<div class="row">
							<div
								class="col-md-6 col-lg-12"
								v-for="intermediary in filteredIntermediaries"
								@click="openModal({ number: 1, intermediary })"
							>
								<div class="intermediary-box">
									<div class="clearfix">
										<div class="image-box f-l">
											<img
												v-if="intermediary.image_path"
												:src="
													api.getDomain() +
													intermediary.image_path
												"
												alt=""
												class="image"
											/>
											<img
												v-else
												src="/img/avatars/2.png"
												alt=""
												class="image"
											/>
										</div>

										<div
											class="name-box f-l"
											v-for="(
												item, index
											) in intermediary.kyc"
											:key="index"
										>
											<div class="insurance">
												{{ item.intermediary_names }}
											</div>

											<div class="txt">
												{{ intermediary.category }}
											</div>
											<div class="txt">
												{{ intermediary.description }}
											</div>
											<Rate
												v-model="intermediary.rating"
												allow-half
												icon="fa fa-star"
												disabled
											/>
										</div>
										<div class="status-box f-r">
											<div class="bx-green">Online</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</scrollbar>
				</div>
			</div>
			<div
				class="col-12 col-lg-6"
				v-if="!intermediaries || intermediaries.length === 0"
			>
				<div class="white-content">
					<div class="title">No Intermediaries Available</div>
				</div>
			</div>
			<div class="col-12 col-lg-5">
				<Advert />
			</div>
		</div>
	</div>
</template>

<script>
import intermediaries from '../rsc/stores/itermediaries.store';
import VueScrollbar from 'vue-scrollbar-simple';
import { mapGetters, mapActions } from 'vuex';

export default {
	beforeCreate() {
		Event.$emit('loader:show', true);
	},
	beforeDestroy() {
		this.$store.unregisterModule('intermediaries');
	},
	created() {
		utils.registerModule('intermediaries', intermediaries, this.$store);
	},
	components: {
		Advert: () => import('../templates/ads/advert'),
		ViewIntermediary: () => import('./view-intermediary.vue'),
		scrollbar: VueScrollbar,
		Dropdown: () => import('@/libs/clarks/components/dropdown/dropdown'),
		DropdownItem: () =>
			import('@/libs/clarks/components/dropdown/dropdown-item'),
		DropdownMenu: () =>
			import('@/libs/clarks/components/dropdown/dropdown-menu'),
		Modal: () => import('../templates/others/modal.vue'),
		Form: () => import('@/libs/clarks/components/form'),
	},
	data() {
		return {
			moment,
			api,
			products: [],
			searchQuery: '',
		};
	},
	computed: {
		...mapGetters([
			'intermediaries',
			'appointments',
			'showAppointmentForm',
			'showIntermediary',
			'showChatUsers',
			'showIntermediaryRequest',
			'SelectedIntermediary',
			'intermediary_requirement_fields',
			'activeTab',
			'loading',
			'proffesions',
			'intermediary_page',
			'request_type',
			'Intermediary',
		]),
		filteredIntermediaries() {
			if (!this.searchQuery) return this.intermediaries;
			return this.intermediaries.filter(
				(intermediary) =>
					intermediary.kyc[0].intermediary_names
						.toLowerCase()
						.includes(this.searchQuery.toLowerCase()) ||
					intermediary.category
						.toLowerCase()
						.includes(this.searchQuery.toLowerCase()) ||
					(intermediary.descriptions &&
						intermediary.descriptions
							.toLowerCase()
							.includes(this.searchQuery.toLowerCase())),
			);
		},
	},
	methods: {
		...mapActions([
			'fetchData',
			'closeModal',
			'openModal',
			'openTab',
			'makeAnAppointment',
			'goToChat',
			'requestQuote',
			'selectProductCatalogue',
			'uploadFilesIntermediary',
			'uploadFiles',
			'fetchIntermediaryChatUsers',
			'setFreeProductForms',
			'setCustomizedProductForms',
			'fetchProductCatalogue',
			'fetchProductReviews',
			'fetchRecommendations',
		]),
		async clickAction(action) {
			switch (action) {
				case 'list_reviews':
					await this.fetchProductReviews();
					this.$store.commit('showListReview', true);
					Event.$emit('loader:show', false);
					break;
				case 'quotation_recomendations':
					(await this.fetchRecommendations(),
						this.$store.commit('showRecommendations', true));
					break;
				case 'add_review':
					this.$store.commit('showAddReviews', true);
					break;
				case 'book_appointment':
					this.$store.commit('showAppointmentForm', true);
					break;
				case 'make_quotation_request':
					await this.fetchProductCatalogue();
					this.$store.commit('intermediary_page', 1);
					this.$store.commit('showIntermediaryRequest', true);
					break;
				case 'chat':
					await this.fetchIntermediaryChatUsers();
					this.$store.commit('showChatUsers', true);
					break;
				default:
					break;
			}
		},
		async filterAction(action) {
			switch (action) {
				case 'near_me':
					break;
				default:
					break;
			}
		},
	},
	mounted() {
		utils.registerModule('intermediaries', intermediaries, this.$store);
		this.fetchData();
	},
};
</script>

<style lang="less">
@grey: #a7abbd;

.intermediaries {
	.proffesion {
		.name {
			font-weight: 600;
			font-size: 14px;

			.class {
				text-transform: uppercase;
				font-size: 13px;
			}
		}

		.description {
			font-size: 14px;
		}
	}
	.appointment {
		.card {
			margin: 5px 10px !important;

			.subject {
				font-size: 13px;
				color: var(--primary);
				font-weight: 600;
			}
			.description {
				font-size: 13px;
			}
			.date {
				color: var(--ne-red);
				font-weight: 600;
				font-size: 14px;
				text-align: right;
			}
		}
	}
	.no-padding {
		margin: 20px -30px !important;
	}
	.rate {
		font-size: 13px !important;
	}
	.top-image {
		background-size: cover;
		background-position: center;
		position: relative;
		padding: 50px 15px;

		.image-content {
			position: absolute;
			background: rgba(0, 0, 0, 0.4);
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			padding: 20px 15px;

			.fx-dropdown {
				position: absolute;
				right: 10px;
				top: 10px;

				.btn-red.btn-sm {
				}
			}
			.insurance {
				font-size: 15px;
				color: var(--white);
			}
			.txt {
				font-size: 13px;
				color: var(--white);
			}
		}
	}

	.scroll-content {
		height: calc(100vh - 230px);
	}
	.white-content {
		background: var(--white);
		border-radius: 4px;
		border: solid 1px #e6eaee;
		padding: 40px 0;
		text-align: center;
		font-size: 14px;
		font-weight: 600;
		color: var(--ne-red);
	}
	.intermediary {
		margin: 30px 0;
	}
	.intermediary-box {
		border-radius: 4px;
		border: solid 1px #e6eaee;
		background: var(--white);
		padding: 20px 15px;
		margin: 10px 0;
		cursor: pointer;

		.image-box {
			margin: 0 30px 0 0;

			.image {
				border-radius: 50%;
				width: 50px;
				height: 50px;
			}
		}
		.bx-green {
			background: var(--ne-green);
			font-size: 12px !important;
			padding: 3px;
			line-height: 10px;
			border-radius: 2px;
			color: var(--white);
			font-weight: 600;
		}
		.insurer {
			color: var(--ne-blue);
			font-weight: 600;
			font-size: 12px;
		}
		.date-box {
			margin: -1px 15px 0 0;

			.txt {
				font-size: 13px;
				margin: 4px 5px 15px 0;
			}
			.month,
			.year {
				color: @grey;
				font-size: 14px;
				font-weight: 600;
				line-height: 12px;
				margin: 8px 5px;
			}
			.date {
				font-size: 16px;
				font-family: var(--font-bold);
				color: var(--text-color);
				margin: 2px 0 2px 5px;
			}
		}
		.name-box {
			.insurance {
				font-size: 17px;
				color: var(--text-color);
				font-family: var(--font-bold);
				line-height: 15px;
			}
			.txt {
				font-weight: 600;
				color: @grey;
				font-size: 14px;
			}
		}

		.status-box {
			.bx-green {
				font-size: 20px;
				line-height: 15px;
				font-family: var(--font-bold);
				margin: 5px 0 0 0;

				.point {
					font-size: 11px;
				}
			}
			.txt {
				font-weight: 600;
				color: @grey;
			}
		}
	}

	.title-content {
		margin: 10px 0 25px 10px;

		.filter {
			font-weight: 600;
			cursor: pointer;

			.icon {
				font-size: 20px;
				margin: 1px 10px 0 0;
			}
		}
		.filter:hover {
			color: var(--ne-red) !important;
		}
	}
}
</style>
